import { useState, useEffect, useCallback, useRef } from 'react';

// Mesajlar (1. aşama, SALT OKUNUR). Veri 5 dakikada bir Ozon'dan DB'ye çekilir (syncChats.js).
// Bu ekrandan mesaj gönderilmez; okundu bilgisi Ozon'daki gibi kalır.

const BASE = '/api';
function api(path) {
  const token = localStorage.getItem('ozon_token');
  return fetch(`${BASE}${path}`, { headers: { Authorization: `Bearer ${token}` } })
    .then(async r => {
      const d = await r.json().catch(() => ({}));
      if (!r.ok) throw new Error(d.error || r.statusText);
      return d;
    });
}

// Ozon tarihleri UTC gelir; ekranda Moskova saatiyle gösterilir.
function formatDate(str, saatli = false) {
  if (!str) return '—';
  return new Date(str).toLocaleString('tr-TR', {
    timeZone: 'Europe/Moscow', day: '2-digit', month: '2-digit', year: 'numeric',
    ...(saatli ? { hour: '2-digit', minute: '2-digit' } : {}),
  });
}

// Ozon chat tipini büyük harfle (BUYER_SELLER), gönderen tipini karışık harfle ("Seller") veriyor;
// karşılaştırmalar büyük harfe çevrilerek yapılır.
const TIP_AD = {
  BUYER_SELLER: 'Müşteri',
  SELLER_SUPPORT: 'Ozon Destek',
  SELLER_NOTIFICATION_UPDATE_CONTENT: 'Bildirim',
  SELLER_API_NOTIFICATIONS: 'API bildirimi',
  UNSPECIFIED: 'Diğer',
};
const GONDEREN_AD = {
  CUSTOMER: 'Müşteri',
  SELLER: 'Biz',
  SUPPORT: 'Ozon Destek',
  NOTIFICATIONUSER: 'Ozon Bildirim',
  CHATBOT: 'Ozon Bot',
};
const buyuk = s => String(s || '').toUpperCase();
const tipAdi = t => TIP_AD[buyuk(t)] || t;

// Müşteri görseli Ozon'dan markdown olarak gelir: "![](https://api-seller.ozon.ru/v2/chat/file/...)".
// Dosya Ozon API anahtarı istediği için tarayıcıda açılamaz; yer tutucu gösterilir.
const GORSEL = /!\[[^\]]*\]\([^)]*\)/g;
const onizleme = t => (t ? t.replace(GORSEL, '📷 Görsel').trim() : t);

// Görünüm ve gönderi durumu anahtarları backend'deki (routes/chats.js) GORUNUM_KOSUL / DURUM_KOSUL ile aynı.
const GORUNUMLER = [
  { key: '',          label: 'Tümü',            sayac: 'tumu' },
  { key: 'cevap',     label: 'Cevap bekleyen',  sayac: 'cevap' },
  { key: 'musteri',   label: 'Müşteri yazmış',  sayac: 'musteri' },
  { key: 'okunmamis', label: 'Okunmamış',       sayac: 'okunmamis' },
];
const DURUMLAR = [
  { key: '',             label: 'Tüm gönderiler' },
  { key: 'hazirlaniyor', label: 'Hazırlanıyor' },
  { key: 'yolda',        label: 'Yolda' },
  { key: 'noktada',      label: 'Teslim noktasında' },
  { key: 'teslim',       label: 'Teslim edildi' },
  { key: 'iptal',        label: 'İptal' },
  { key: 'yok',          label: 'Gönderi bağlı değil' },
];
const DURUM_AD = {
  awaiting_packaging: 'Hazırlanıyor', awaiting_deliver: 'Sevke hazır', delivering: 'Yolda',
  delivered: 'Teslim edildi', cancelled: 'İptal',
};
const durumAdi = c => (c.status === 'delivering' && c.substatus === 'posting_in_pickup_point'
  ? 'Noktada' : DURUM_AD[c.status] || c.status);

// Moskova gününe göre YYYY-MM-DD (backend bas/bit'i Moskova günü olarak yorumlar).
const moskovaGunu = (gunOnce = 0) =>
  new Date(Date.now() - gunOnce * 86400000).toLocaleDateString('sv-SE', { timeZone: 'Europe/Moscow' });
const TARIHLER = [
  { key: '',     label: 'Tüm tarihler' },
  { key: 'bugun', label: 'Bugün',      bas: () => moskovaGunu(0) },
  { key: '7',    label: 'Son 7 gün',  bas: () => moskovaGunu(6) },
  { key: '30',   label: 'Son 30 gün', bas: () => moskovaGunu(29) },
  { key: 'ozel', label: 'Tarih aralığı…' },
];

// "3 sa", "2 gün" — cevap bekleme süresi.
function beklemeSuresi(str) {
  const dk = Math.max(0, Math.round((Date.now() - new Date(str).getTime()) / 60000));
  if (dk < 60) return `${dk} dk`;
  if (dk < 48 * 60) return `${Math.round(dk / 60)} sa`;
  return `${Math.round(dk / 1440)} gün`;
}

function MesajBalonu({ m }) {
  const biz = buyuk(m.user_type) === 'SELLER';
  const musteri = buyuk(m.user_type) === 'CUSTOMER';
  const hizalama = biz ? 'justify-end' : musteri ? 'justify-start' : 'justify-center';
  const renk = biz ? 'bg-blue-600 text-white' : musteri ? 'bg-white border border-gray-200 text-gray-900' : 'bg-gray-100 text-gray-600';
  return (
    <div className={`flex ${hizalama}`}>
      <div className={`max-w-[75%] rounded-2xl px-3 py-2 text-sm ${renk}`}>
        {!biz && !musteri && <div className="text-[11px] font-semibold mb-0.5">{GONDEREN_AD[buyuk(m.user_type)] || m.user_type}</div>}
        {m.is_image
          ? <span className="italic opacity-80">📷 Görsel — Ozon panelinden açılabilir</span>
          : <div className="whitespace-pre-wrap break-words">{onizleme(m.text) || '—'}</div>}
        <div className={`text-[11px] mt-1 ${biz ? 'text-blue-100' : 'text-gray-400'}`}>
          {formatDate(m.created_at, true)}
          {musteri && m.is_read === false && <span className="ml-1 text-orange-500 font-semibold">· okunmadı</span>}
        </div>
      </div>
    </div>
  );
}

function Konusma({ chatId }) {
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState('');
  const alt = useRef(null);

  useEffect(() => {
    setVeri(null); setHata('');
    api(`/chats/${encodeURIComponent(chatId)}`).then(setVeri).catch(e => setHata(e.message));
  }, [chatId]);

  useEffect(() => { alt.current?.scrollIntoView(); }, [veri]);

  if (hata) return <div className="p-6 text-sm text-red-600">{hata}</div>;
  if (!veri) return <div className="p-6 text-sm text-gray-400">Yükleniyor…</div>;
  const { chat, mesajlar, siparisler } = veri;
  return (
    <div className="flex flex-col h-full">
      <div className="px-4 py-3 border-b border-gray-100 bg-white">
        <div className="flex items-center gap-2 text-sm">
          <span className="font-semibold text-gray-900">{tipAdi(chat.chat_type)}</span>
          {(chat.posting_number || chat.order_number) && <span className="font-mono text-xs text-gray-500">{chat.posting_number || `sipariş ${chat.order_number}`}</span>}
          {buyuk(chat.chat_status) === 'CLOSED' && <span className="text-xs px-2 py-0.5 rounded-full bg-gray-100 text-gray-500">kapalı</span>}
        </div>
        {siparisler.map(s => (
          <div key={s.posting_number} className="text-xs text-gray-500 mt-1">
            <span className="font-mono">{s.posting_number}</span> · {s.status}
            {s.musteri_adi && <> · {s.musteri_adi}</>}
            {(s.teslim_baslangic || s.teslim_bitis) && <> · teslim {formatDate(s.teslim_baslangic)}{s.teslim_bitis && ` – ${formatDate(s.teslim_bitis)}`}</>}
            {s.urunler && <div className="truncate">{s.urunler}</div>}
          </div>
        ))}
      </div>
      <div className="flex-1 overflow-y-auto p-4 space-y-2 bg-gray-50">
        {mesajlar.map(m => <MesajBalonu key={m.message_id} m={m} />)}
        {!mesajlar.length && <div className="text-sm text-gray-400">Mesaj yok.</div>}
        <div ref={alt} />
      </div>
      <div className="px-4 py-2 border-t border-gray-100 bg-white text-xs text-gray-400">
        Bu ekran salt okunur — cevap şimdilik Ozon panelinden yazılır.
      </div>
    </div>
  );
}

export default function Messages() {
  const [veri, setVeri] = useState(null);
  const [hata, setHata] = useState('');
  const [tip, setTip] = useState('BUYER_SELLER');
  const [gorunum, setGorunum] = useState('');
  const [durum, setDurum] = useState('');
  const [tarih, setTarih] = useState('');
  const [ozelBas, setOzelBas] = useState('');
  const [ozelBit, setOzelBit] = useState('');
  const [ara, setAra] = useState('');
  const [aranan, setAranan] = useState('');
  const [secili, setSecili] = useState(null);

  const yukle = useCallback(() => {
    const q = new URLSearchParams();
    if (tip) q.set('tip', tip);
    if (gorunum) q.set('gorunum', gorunum);
    if (durum) q.set('durum', durum);
    if (tarih === 'ozel') {
      if (ozelBas) q.set('bas', ozelBas);
      if (ozelBit) q.set('bit', ozelBit);
    } else {
      const t = TARIHLER.find(x => x.key === tarih);
      if (t?.bas) q.set('bas', t.bas());
    }
    if (aranan) q.set('ara', aranan);
    api(`/chats?${q}`).then(d => { setVeri(d); setHata(''); }).catch(e => setHata(e.message));
  }, [tip, gorunum, durum, tarih, ozelBas, ozelBit, aranan]);

  useEffect(() => {
    yukle();
    const id = setInterval(yukle, 60000); // veri 5 dk'da bir geliyor; ekran dakikada bir yenilenir
    return () => clearInterval(id);
  }, [yukle]);

  const s = veri?.senkron;
  return (
    <div className="p-6">
      <div className="flex items-start justify-between mb-4 gap-4 flex-wrap">
        <div>
          <h1 className="text-xl font-bold text-gray-900">Mesajlar</h1>
          <p className="text-xs text-gray-500 mt-1">
            Ozon chat'leri, 5 dakikada bir güncellenir.
            {s && <> Son güncelleme: {formatDate(s.finished_at || s.started_at, true)}
              {s.ok === false && <span className="text-red-600"> — hata: {(s.message || '').slice(0, 160)}</span>}
              {s.ok === null && !s.finished_at && <span className="text-blue-600"> — sürüyor</span>}
            </>}
          </p>
        </div>
        <div className="flex items-center gap-2 flex-wrap">
          <select value={tip} onChange={e => { setTip(e.target.value); setSecili(null); }}
            className="border border-gray-200 rounded-xl px-3 py-2 text-sm">
            <option value="">Tüm chat'ler</option>
            {(veri?.tipler || []).map(t => (
              <option key={t.chat_type} value={t.chat_type}>
                {tipAdi(t.chat_type)} ({t.n}{t.okunmamis ? `, ${t.okunmamis} okunmamış` : ''})
              </option>
            ))}
            {!veri?.tipler?.some(t => t.chat_type === 'BUYER_SELLER') && <option value="BUYER_SELLER">Müşteri</option>}
          </select>
          <select value={durum} onChange={e => { setDurum(e.target.value); setSecili(null); }}
            className="border border-gray-200 rounded-xl px-3 py-2 text-sm">
            {DURUMLAR.map(d => <option key={d.key} value={d.key}>{d.label}</option>)}
          </select>
          <select value={tarih} onChange={e => { setTarih(e.target.value); setSecili(null); }}
            className="border border-gray-200 rounded-xl px-3 py-2 text-sm">
            {TARIHLER.map(t => <option key={t.key} value={t.key}>{t.label}</option>)}
          </select>
          {tarih === 'ozel' && <>
            <input type="date" value={ozelBas} onChange={e => setOzelBas(e.target.value)}
              className="border border-gray-200 rounded-xl px-2 py-1.5 text-sm" />
            <span className="text-gray-400 text-sm">–</span>
            <input type="date" value={ozelBit} onChange={e => setOzelBit(e.target.value)}
              className="border border-gray-200 rounded-xl px-2 py-1.5 text-sm" />
          </>}
          <form onSubmit={e => { e.preventDefault(); setAranan(ara.trim()); }}>
            <input value={ara} onChange={e => setAra(e.target.value)} placeholder="Sipariş no / metin ara"
              className="border border-gray-200 rounded-xl px-3 py-2 text-sm w-56 focus:outline-none focus:border-blue-400" />
          </form>
        </div>
      </div>

      <div className="flex gap-2 mb-3 flex-wrap">
        {GORUNUMLER.map(g => {
          const n = veri?.sayac?.[g.sayac];
          const aktif = gorunum === g.key;
          return (
            <button key={g.key} onClick={() => { setGorunum(g.key); setSecili(null); }}
              className={`text-sm px-3 py-1.5 rounded-xl border ${aktif
                ? 'bg-gray-900 text-white border-gray-900'
                : 'bg-white text-gray-600 border-gray-200 hover:bg-gray-50'}`}>
              {g.label}
              {n != null && <span className={`ml-1.5 text-xs ${aktif ? 'text-gray-300'
                : g.key === 'cevap' && n > 0 ? 'text-orange-600 font-semibold' : 'text-gray-400'}`}>{n}</span>}
            </button>
          );
        })}
        {veri && veri.chatler.length >= 300 && <span className="text-xs text-gray-400 self-center">İlk 300 gösteriliyor — filtreyi daralt.</span>}
      </div>

      {hata && <div className="mb-3 text-sm text-red-600">{hata}</div>}

      <div className="bg-white rounded-2xl border border-gray-100 overflow-hidden flex" style={{ height: 'calc(100vh - 215px)' }}>
        <div className="w-96 border-r border-gray-100 overflow-y-auto flex-shrink-0">
          {!veri && <div className="p-4 text-sm text-gray-400">Yükleniyor…</div>}
          {veri && !veri.chatler.length && <div className="p-4 text-sm text-gray-400">Chat yok.</div>}
          {veri?.chatler.map(c => (
            <button key={c.chat_id} onClick={() => setSecili(c.chat_id)}
              className={`w-full text-left px-4 py-3 border-b border-gray-50 hover:bg-gray-50 ${secili === c.chat_id ? 'bg-blue-50' : ''}`}>
              <div className="flex items-center justify-between gap-2">
                <span className="text-sm font-semibold text-gray-900 truncate">
                  {c.musteri_adi || (c.posting_number || (c.order_number ? `Sipariş ${c.order_number}` : tipAdi(c.chat_type)))}
                </span>
                <span className="text-[11px] text-gray-400 whitespace-nowrap">{formatDate(c.last_message_at, true)}</span>
              </div>
              <div className="flex items-center justify-between gap-2 mt-0.5">
                <span className="text-xs text-gray-500 truncate">
                  {buyuk(c.last_message_from) === 'SELLER' && <span className="text-blue-600">Biz: </span>}
                  {onizleme(c.last_message_text) || '—'}
                </span>
                {c.unread_count > 0 && (
                  <span className="text-[11px] bg-orange-500 text-white rounded-full px-1.5 min-w-[20px] text-center">{c.unread_count}</span>
                )}
              </div>
              <div className="flex items-center gap-2 mt-0.5 text-[11px]">
                {(c.posting_number || c.order_number) && c.musteri_adi && <span className="font-mono text-gray-400">{c.posting_number || c.order_number}</span>}
                {c.status && <span className="text-gray-400">· {durumAdi(c)}</span>}
                {c.cevap_bekliyor && (
                  <span className="ml-auto text-orange-600 font-semibold whitespace-nowrap">⏳ {beklemeSuresi(c.son_musteri_at)}</span>
                )}
              </div>
            </button>
          ))}
        </div>
        <div className="flex-1 min-w-0">
          {secili ? <Konusma chatId={secili} /> : <div className="p-6 text-sm text-gray-400">Soldan bir chat seç.</div>}
        </div>
      </div>
    </div>
  );
}
